<template>
<div>
	<div v-if="show" class="c-tabs t-margin-bottom-m c-vue-tabs">
		<ul class="o-list-inline c-tabs__list">
			<li class="o-list-inline__item c-tabs__item" 
				:class="{ 'c-tabs__item--active' : currentTab === tab }" 
				v-for="(tab, index) in tabs" 
				:key="index">
				<slot v-if="index === 1" name="notify"></slot>
				<a href="#" class="c-tabs__title" @click.prevent="handleClick(tab)">
					{{tab}}
				</a>
			</li>
		</ul>
	</div>
	<div v-if="currentTab === tab" class="tab-content" v-for="tab in tabs" :key="tab">
		<slot :name="tab"></slot>
	</div>
</div>
</template>
<script>
export default {
    name: 'VueTabs',
    props: {
		show: {
			type: Boolean,
			default: true,
		},
    },
    data: () => ({
		currentTab: ''
	}),
    methods: {
		handleClick(tab) {
			this.currentTab = tab;
			this.$emit('tabSwitched', tab);
		},
	},
	computed: {
		tabs() {
			return Object.keys(this.$slots).filter(key => key !== 'notify');
		}
	},
    created() {
		this.currentTab = this.tabs[0];
	}
}
</script>
